module.exports = __webpack_public_path__ + "static/Ferie-2022-Acro-Dance-Fun-ulotka-91a2e87adfa082e51cd6446207443b8c.pdf";